import { render } from "./UserSettings.vue?vue&type=template&id=47b473ca&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"

import "./UserSettings.vue?vue&type=style&index=0&id=47b473ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b473ca"]])

export default __exports__